export const SET_USER_DATA = 'SET_USER_DATA';
export const REMOVE_USER_DATA = 'REMOVE_USER_DATA';
export const SET_SIGNIN_DATA = 'SET_SIGNIN_DATA';
export const SET_POSTS_CATEGORIES = 'SET_POSTS_CATEGORIES';
